import src from "IMAGE";
export default { src, width: 320, height: 96, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AD1QVVVERkfsLS8v8i0vL/IuLy/yKy0t8iEjJOw7T1RVAD1RVlVXWVrsNzg58j5AQPI1NjfyOTs78i0vMOw8T1VV/R8Xxuxfb4oAAAAASUVORK5CYII="};
